import React, { useEffect } from "react";
import { Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowClockwise } from "react-icons/bs";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";

const FREIGHT_LIVE_PM_KPI = ({data, changeValues, filter, showModalCalRange}) => {

    const { setValues, values, calculoDias, calculoYesNo, calculoPerType, calculoPerTypeStatus, calculoFundingSources } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
        const datas = {
            project_type: {
                infrastructure: calculoPerType('type_foreseen_interven', 'infrastructure', filter.yearInit),
                reconstruction: calculoPerType('type_foreseen_interven', 'reconstruction', filter.yearInit),
                maintenances: calculoPerType('type_foreseen_interven', 'maintenances', filter.yearInit),
                horizontal: calculoPerType('type_foreseen_interven', 'horizontal', filter.yearInit)
            },
            TEN_TCompliance: { 
                inter_modality: {
                    bef_inter_modality: calculoYesNo('bef_inter_modality', filter.yearInit),
                    aft_inter_modality: calculoYesNo('aft_inter_modality', filter.yearInit)
                },
                train_length_740m: {
                    bef_train_length_740m: calculoYesNo('bef_train_length_740m', filter.yearInit),
                    aft_train_length_740m: calculoYesNo('aft_train_length_740m', filter.yearInit)
                },
                electrification: {
                    bef_electrification: calculoYesNo('bef_electrification'),
                    aft_electrification: calculoYesNo('aft_electrification', filter.yearInit)
                }, 
                open_avail: {
                    bef_open_avail: calculoYesNo('bef_open_avail', filter.yearInit),
                    aft_open_avail: calculoYesNo('aft_open_avail', filter.yearInit)
                },
            },
            project_status: {
                status_high_level: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: calculoPerTypeStatus('ongoing_proj_fs', filter.yearInit),
                    mature_proj_fs: calculoPerTypeStatus('mature_proj_fs', filter.yearInit),
                    proj_under_prep: calculoPerTypeStatus('proj_under_prep', filter.yearInit)
                }, 
                status_detailed: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: {
                        workCur: calculoPerType('ongoing_proj_fs', 'workCur', filter.yearInit),
                        tenderWork: calculoPerType('ongoing_proj_fs', 'tenderWork', filter.yearInit),
                        designTender: calculoPerType('ongoing_proj_fs', 'designTender', filter.yearInit),
                        tenderOngoing: calculoPerType('ongoing_proj_fs', 'tenderOngoing', filter.yearInit)
                    },
                    mature_proj_fs: {
                        finOngoing: calculoPerType('mature_proj_fs', 'finOngoing', filter.yearInit),
                        finProceduresNotyetStarted: calculoPerType('mature_proj_fs', 'finProceduresNotyetStarted', filter.yearInit),
                        finSourceNotInd: calculoPerType('mature_proj_fs', 'finSourceNotInd', filter.yearInit)
                    },
                    proj_under_prep: {
                        feasOnGoing: calculoPerType('proj_under_prep', 'feasOnGoing', filter.yearInit),
                        feasUnderTen: calculoPerType('proj_under_prep', 'feasUnderTen', filter.yearInit),
                        financing: calculoPerType('proj_under_prep', 'financing', filter.yearInit)
                    }
                }
            },
            project_funding: {
                funding_source: {
                    proj_fund_nat_budg: calculoFundingSources('proj_fund_nat_budg', filter.yearInit),
                    proj_fund_wb: calculoFundingSources('proj_fund_wb', filter.yearInit),
                    proj_fund_ebrd: calculoFundingSources('proj_fund_ebrd', filter.yearInit),
                    proj_fund_eib: calculoFundingSources('proj_fund_eib', filter.yearInit),
                    other_ifi: calculoFundingSources('other_ifi', filter.yearInit),
                    concessions: calculoFundingSources('concessions', filter.yearInit),
                    eu_fund: calculoFundingSources('eu_fund', filter.yearInit),
                    other_fund: calculoFundingSources('other_fund', filter.yearInit)
                },
                allocated_funding: {
                    proj_fund_nat_budg: calculoYesNo('proj_fund_nat_budg', filter.yearInit),
                    proj_fund_wb: calculoYesNo('proj_fund_wb', filter.yearInit),
                    proj_fund_ebrd: calculoYesNo('proj_fund_ebrd', filter.yearInit),
                    proj_fund_eib: calculoYesNo('proj_fund_eib', filter.yearInit),
                    other_ifi: calculoYesNo('other_ifi', filter.yearInit),
                    concessions: calculoYesNo('concessions', filter.yearInit),
                    eu_fund: calculoYesNo('eu_fund', filter.yearInit),
                    other_fund: calculoYesNo('other_fund', filter.yearInit)
                }
            },
            project_timeline: {
                tender_start_date: calculoDias('tender_start_date_curr_est', 'tender_start_date_init_fore', null, filter.yearInit),
                design_comp_date: calculoDias('design_comp_date_curr_est', 'design_comp_date_fore', null, filter.yearInit),
                proj_comp_date: calculoDias('proj_comp_date_curr_est', 'proj_comp_date_fore', null, filter.yearInit)
            },
            project_tech_status: {
                pre_feasi_study: calculoYesNo('pre_feasi_study', filter.yearInit),
                feasi_study: calculoYesNo('feasi_study', filter.yearInit),
                concept_design: calculoYesNo('concept_design', filter.yearInit),
                prelim_design: calculoYesNo('prelim_design', filter.yearInit),
                detail_design: calculoYesNo('detail_design', filter.yearInit),
                environ_impact_assess: calculoYesNo('environ_impact_assess', filter.yearInit)
            },
            social_indicators: {
                si_ann_traff_dem_gro: "",
                si_modal_trans: "",
                si_ann_traff_acci_rate_red: ""
            },
            eco_indicators: {
                ei_eirr: "",
                ei_npv: "",
                ei_sdr: "",
                ei_proj_plan_des_cost: "",
                ei_proj_const_cost: "",
                ei_total_proj_cost: ""
            },
            financial_indicators: {
                fi_firr: "",
                fi_fnpv: "",
                fi_fdr: "",
                fi_wacc: "",
                fi_firts_year_prof: "",
                fi_dscr: ""
            },
            environmental_indicators: {
                eni_co2_ems: "",
                eni_nox_ems: "",
                eni_so2_ems: "",
                eni_nmhc_ems: "",
                eni_ppm: "",
                eni_noise_level: "",
                eni_cli_change_res: "",
                eni_prote_natua_aff: ""
            }
        }

        changeValues(datas)
    }

    return (
        <Tabs defaultActiveKey="project_type" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="project_type" title="Project Type" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.infrastructure" label="New infrastructure" name="project_type.infrastructure" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.reconstruction" label="Reconstruction/rehabilitation" name="project_type.reconstruction" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.maintenances" label="Maintenance" name="project_type.maintenances" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.horizontal" label="Horizontal/policy measure" name="project_type.horizontal" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="TEN_TCompliance" title="TEN-T Compliance" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.inter_modality.bef_inter_modality" label="Inter-modality (before)" name="TEN_TCompliance.inter_modality.bef_inter_modality" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.inter_modality.aft_inter_modality" label="Inter-modality (after)" name="TEN_TCompliance.inter_modality.aft_inter_modality" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.train_length_740m.bef_train_length_740m" label="740m train length (before)" name="TEN_TCompliance.train_length_740m.bef_train_length_740m" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.train_length_740m.aft_train_length_740m" label="740m train length (after)" name="TEN_TCompliance.train_length_740m.aft_train_length_740m" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.electrification.bef_electrification" label="Electrified access (before)" name="TEN_TCompliance.electrification.bef_electrification" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.electrification.aft_electrification" label="Electrified access (after)" name="TEN_TCompliance.electrification.aft_electrification" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.open_avail.bef_open_avail" label="Open availability (before)" name="TEN_TCompliance.open_avail.bef_open_avail" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.open_avail.aft_open_avail" label="Open availability (after)" name="TEN_TCompliance.open_avail.aft_open_avail" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_status" title="Project Status" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Status (high level)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.implemented" label="% Implemented" name="project_status.status_high_level.implemented" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.ongoing_proj_fs" label="% On-going project (funding secured)" name="project_status.status_high_level.ongoing_proj_fs" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.mature_proj_fs" label="% Mature project (feasibility study ready, funding secured)" name="project_status.status_high_level.mature_proj_fs" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.proj_under_prep" label="% Project under preparation" name="project_status.status_high_level.proj_under_prep" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Status (detailed)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_detailed.implemented" label="% Implemented" name="project_status.status_detailed.implemented" disabled={true}/>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>On-going project (funding secured)</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.workCur" label="% Works currently under execution" name="project_status.status_detailed.ongoing_proj_fs.workCur" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderWork" label="% Tender for works/design-build on-going" name="project_status.status_detailed.ongoing_proj_fs.tenderWork" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.designTender" label="% Design/Tender Dossier for DB under preparation" name="project_status.status_detailed.ongoing_proj_fs.designTender" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" label="% Tender for design on-going or about to be start" name="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Mature project (feasibility study ready, funding secured)</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finOngoing" label="% Procedures on-going" name="project_status.status_detailed.mature_proj_fs.finOngoing" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" label="% Procedures not-yet-started" name="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finSourceNotInd" label="% Financing source not identified" name="project_status.status_detailed.mature_proj_fs.finSourceNotInd" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Project under preparation</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasOnGoing" label="% Feasibility study on-going" name="project_status.status_detailed.proj_under_prep.feasOnGoing" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasUnderTen" label="% Feasibility study under tendering" name="project_status.status_detailed.proj_under_prep.feasUnderTen" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.financing" label="% Procurement not yet started" name="project_status.status_detailed.proj_under_prep.financing" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_funding" title="Project Funding" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Funding Sources</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_nat_budg" label="% National Budget" name="project_funding.funding_source.proj_fund_nat_budg" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_wb" label="% WB" name="project_funding.funding_source.proj_fund_wb" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_ebrd" label="% EBRD" name="project_funding.funding_source.proj_fund_ebrd" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_eib" label="% EIB" name="project_funding.funding_source.proj_fund_eib" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_ifi" label="% Other IFI" name="project_funding.funding_source.other_ifi" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.concessions" label="% Concessions" name="project_funding.funding_source.concessions" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.eu_fund" label="% EU Fund" name="project_funding.funding_source.eu_fund" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_fund" label="% Other funding source" name="project_funding.funding_source.other_fund" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Allocated Funding</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_nat_budg" label="% National Budget" name="project_funding.allocated_funding.proj_fund_nat_budg" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_wb" label="% WB" name="project_funding.allocated_funding.proj_fund_wb" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_ebrd" label="% EBRD" name="project_funding.allocated_funding.proj_fund_ebrd" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_eib" label="% EIB" name="project_funding.allocated_funding.proj_fund_eib" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.other_ifi" label="% Other IFI" name="project_funding.allocated_funding.other_ifi" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.concessions" label="% Concessions" name="project_funding.allocated_funding.concessions" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.eu_fund" label="% EU Fund" name="project_funding.allocated_funding.eu_fund" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.other_fund" label="% Other funding source" name="project_funding.allocated_funding.other_fund" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_timeline" title="Project Timeline" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_timeline.tender_start_date" label="Tender Start Date" name="project_timeline.tender_start_date" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_timeline.design_comp_date" label="Design Completion Date" name="project_timeline.design_comp_date" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_timeline.proj_comp_date" label="Project Completion Date" name="project_timeline.proj_comp_date" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_tech_status" title="Project Technical Status" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.pre_feasi_study" label="Pre-Feasibility Study" name="project_tech_status.pre_feasi_study" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.feasi_study" label="Feasibility Study" name="project_tech_status.feasi_study" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.concept_design" label="Concept Design" name="project_tech_status.concept_design" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.prelim_design" label="Preliminary Design" name="project_tech_status.prelim_design" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.detail_design" label="Detail Design" name="project_tech_status.detail_design" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.environ_impact_assess" label="Environmental Impact Assessment" name="project_tech_status.environ_impact_assess" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="social_indicators" title="Social Indicators" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="social_indicators.si_ann_traff_dem_gro" label="Annual Traffic Demand Growth" name="social_indicators.si_ann_traff_dem_gro" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("social_indicators.si_ann_traff_dem_gro", "si_ann_traff_dem_gro")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="social_indicators.si_modal_trans" label="Modal transfer (%) (if applicable)" name="social_indicators.si_modal_trans" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("social_indicators.si_modal_trans", "si_modal_trans")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="social_indicators.si_ann_traff_acci_rate_red" label="Annual Accident Rate Reduction" name="social_indicators.si_ann_traff_acci_rate_red" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("social_indicators.si_ann_traff_acci_rate_red", "si_ann_traff_acci_rate_red")}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="eco_indicators" title="Economic Indicators" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_eirr" label="EIRR (Economic Internal Rate of Return)" name="eco_indicators.ei_eirr" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("eco_indicators.ei_eirr", "ei_eirr")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_npv" label="NPV (Net Present Value)" name="eco_indicators.ei_npv" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("eco_indicators.ei_npv", "ei_npv")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_sdr" label="SDR (Social Discount Rate)" name="eco_indicators.ei_sdr" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("eco_indicators.ei_sdr", "ei_sdr")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_proj_plan_des_cost" label="Project Planning & Design Cost" name="eco_indicators.ei_proj_plan_des_cost" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("eco_indicators.ei_proj_plan_des_cost", "ei_proj_plan_des_cost")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_proj_const_cost" label="Project Construction Cost" name="eco_indicators.ei_proj_const_cost" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("eco_indicators.ei_proj_const_cost", "ei_proj_const_cost")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_total_proj_cost" label="Total Project Cost" name="eco_indicators.ei_total_proj_cost" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("eco_indicators.ei_total_proj_cost", "ei_total_proj_cost")}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="financial_indicators" title="Financial Indicators" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_firr" label="FIRR (Financial Internal Rate of Return)" name="financial_indicators.fi_firr" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("financial_indicators.fi_firr", "fi_firr")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_fnpv" label="FNPV (Financial Net Present Value)" name="financial_indicators.fi_fnpv" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("financial_indicators.fi_fnpv", "fi_fnpv")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_fdr" label="FDR (Financial Discount Rate)" name="financial_indicators.fi_fdr" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("financial_indicators.fi_fdr", "fi_fdr")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_wacc" label="WACC (Weighted Average Cost of Capital)" name="financial_indicators.fi_wacc" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("financial_indicators.fi_wacc", "fi_wacc")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_firts_year_prof" label="First year of profit" name="financial_indicators.fi_firts_year_prof" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("financial_indicators.fi_firts_year_prof", "fi_firts_year_prof")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_dscr" label="DSCR (Debt Service Coverage Ratio)" name="financial_indicators.fi_dscr" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("financial_indicators.fi_dscr", "fi_dscr")}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="environmental_indicators" title="Environmental Indicators" className={style.tabHeight} style={{height: "62vh"}}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_co2_ems" label="CO2 emissions" name="environmental_indicators.eni_co2_ems" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_co2_ems", "eni_co2_ems")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_nox_ems" label="NOx emissions" name="environmental_indicators.eni_nox_ems" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_nox_ems", "eni_nox_ems")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_so2_ems" label="SO2 emission evolution" name="environmental_indicators.eni_so2_ems" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_so2_ems", "eni_so2_ems")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_nmhc_ems" label="Non-methane hydrocarbons" name="environmental_indicators.eni_nmhc_ems" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_nmhc_ems", "eni_nmhc_ems")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_ppm" label="Particulate matter (ppm)" name="environmental_indicators.eni_ppm" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_ppm", "eni_ppm")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_noise_level" label="Noise levels along the section" name="environmental_indicators.eni_noise_level" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_noise_level", "eni_noise_level")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_cli_change_res" label="Climate Change Resilience" name="environmental_indicators.eni_cli_change_res" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_cli_change_res", "eni_cli_change_res")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_prote_natua_aff" label="Protected Natural Areas Affected" name="environmental_indicators.eni_prote_natua_aff" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("environmental_indicators.eni_prote_natua_aff", "eni_prote_natua_aff")}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default FREIGHT_LIVE_PM_KPI;